import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate } from '../../../utils/article-date-time'
import { BsCheckLg, BsArrowRightCircle } from 'react-icons/bs'
import { AppInstall } from '../../../components/index/AppInstall'
import Link from 'next/link'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-25'

export async function getStaticProps() {
    const { modifiedDate } = contentDate(CONTENT_REVIEWED)

  return {
      props: {
        modifiedDate
      },
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate

  return (
    <>
      <Head>
        <title>Personal Trainer Jobs Singapore: S$35-50 per Session</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Personal trainer jobs in Singapore: train StringsSG clients at their homes, condo gyms and parks. Full-time or part-time contract paying S$35 to S$50 per 1-hour session, plus bonuses."/>
        <meta name="keywords" content="Personal Trainer Jobs, Fitness Trainer Careers, Singapore Personal Training, StringsSG Careers"/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/personal-trainer/careers" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content="Personal Trainer Jobs Singapore: S$35-50 per Session"/>
        <meta property="og:description" content="Personal trainer jobs in Singapore: train StringsSG clients at their homes, condo gyms and parks. Full-time or part-time contract paying S$35 to S$50 per 1-hour session, plus bonuses." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-01T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/personal-trainer/generated/team-of-personal-trainer-vector.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/personal-trainer/generated/team-of-personal-trainer-vector.jpg" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content="https://www.stringssg.com/sg/personal-trainer/careers"/>
        <meta name="twitter:title" content="Personal Trainer Jobs Singapore: S$35-50 per Session"/>
        <meta name="twitter:description" content="Personal trainer jobs in Singapore: train StringsSG clients at their homes, condo gyms and parks. Full-time or part-time contract paying S$35 to S$50 per 1-hour session, plus bonuses."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"JobPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/careers"},"title":"Personal Trainer","headline":"Personal Trainer Jobs | StringsSG","description":"Personal trainer jobs in Singapore: train StringsSG clients at their homes, condo gyms and parks. Full-time or part-time contract paying S$35 to S$50 per 1-hour session, plus bonuses.","hiringOrganization":{"@type":"Organization","name":"StringsSG","sameAs":"https://www.stringssg.com","logo":"https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/logo.png"},"jobLocation":{"@type":"Place","address":{"@type":"PostalAddress","addressCountry":"SG","addressLocality":"Singapore","postalCode":"409051","addressRegion":"AP","streetAddress":"60 Paya Lebar Rd"}},"employmentType":["FULL_TIME","PART_TIME"],"baseSalary":{"@type":"MonetaryAmount","currency":"SGD","value":{"@type":"QuantitativeValue","minValue":35,"maxValue":50,"unitText":"HOUR"}},"validThrough":"2027-04-30","datePosted":"2026-10-25","datePublished":"2025-01-01T07:30:46+00:00","dateModified":"${modifiedDate}","image":["https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/personal-trainer/generated/team-of-personal-trainer-vector.jpg"],"publisher":{"@type":"Organization","name":"StringsSG","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/logo.png"}}},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Singapore","item":"https://www.stringssg.com/sg"},{"@type":"ListItem","position":2,"name":"Personal Trainer Singapore","item":"https://www.stringssg.com/sg/personal-trainer"},{"@type":"ListItem","position":3,"name":"Personal Trainer Jobs","item":"https://www.stringssg.com/sg/personal-trainer/careers"}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/careers"/>
        </Head>
        <div>
            <div id="fitness-trainer" className="-mt-14 relative overflow-hidden" style={{height : "700px"}}>
                <div className="h-full w-full relative">
                <Image className='bg-linear-to-br from-slate-800 to-orange-300'
                    src={s3Static + "personal-trainer/personal-trainers.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'top'}}
                    alt='StringsSG Personal Trainer Careers'
                    priority="false"
                    quality={100}
                    />
                </div>
                <div id="campaign" className='absolute flex justify-between items-center left-0 bottom-0 top-0 w-full'>
                    <div className='bg-black/50 rounded-lg w-fit mx-auto py-10 px-4 md:px-10 text-center text-white'>
                        <h1 className='text-2xl md:text-4xl pt-5'><strong>Personal Trainer Jobs Singapore</strong></h1>
                        <div className='text-lg md:text-2xl pt-5'><strong>Join Our Team</strong></div>
                    </div>
                </div>
            </div>
            <div className='max-w-5xl mx-auto py-6 px-2'>
                <div className='grid md:grid-cols-2 gap-10 items-center'>
                    <div className='space-y-2 leading-8 text-sm'>
                        <p>
                            StringsSG is on a mission to deliver high-quality, mobile personal training across Singapore — at client homes, condo gyms, and outdoor spaces. We&apos;re not a gym. We bring fitness to the client.
                        </p>
                        <p>
                            We&apos;re looking for passionate Personal Trainers at all levels to join our growing team and make a difference in clients&apos; lives.
                        </p>
                    </div>
                    <div className='relative w-full h-72'>
                        <Image
                            src={s3Static + "personal-trainer/personal-trainer-png.png"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'top'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Personal Trainer Careers - StringsSG'
                        />
                    </div>
                </div>
            </div>
            <AppInstall/>
            <div className="h-120 w-full relative bg-black">
                <Image className='bg-linear-to-br from-slate-800 to-orange-300 opacity-60'
                    src={s3Static + "personal-trainer/fitness-model-couple.png"}
                    fill
                    style={{objectFit: 'contain', objectPosition: 'bottom'}}
                    alt='StringsSG Personal Trainer Team'
                    priority="false"
                />
                <div className='absolute flex justify-between items-center left-0 right-0 bottom-0 top-0 max-w-5x'>
                    <div className='mx-auto p-5 space-y-10 text-center text-white'>
                        <div className='text-2xl uppercase'><strong>What We Offer</strong></div>
                        <div className='py-3 text-xl space-y-8'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>S$35 to S$50 per Session, Plus Bonuses</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Career Growth Opportunities</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Flexible Mobile Training</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Supportive Team Environment</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Key Responsibilities</strong>
                </h2>
                <div className='max-w-5xl mx-auto md:grid md:grid-cols-2 gap-5 p-5'>
                    <div className='py-2 flex items-center'>
                        <div className='space-y-5 leading-8'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Deliver 1-on-1 personal training at homes, condo gyms, or outdoor locations</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Customize fitness programs based on client goals and fitness levels</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Motivate, track progress, and ensure safe, effective workouts</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Deliver engaging trial sessions that demonstrate value and build trust</span>
                            </div>
                        </div>
                    </div>
                    <div className='p-2 flex justify-center items-center'>
                        <Image className='rounded-2xl'
                            src={s3Static + "personal-trainer/generated/team-of-personal-trainer-vector.jpg"}
                            height={350}
                            width={350}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='StringsSG Personal Trainer Responsibilities'
                        />
                    </div>
                </div>
            </div>
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Requirements</strong>
                </h2>
                <div className='max-w-5xl mx-auto md:grid md:grid-cols-2 gap-5 p-5'>
                    <div className='p-2 flex justify-center items-center'>
                        <Image className='rounded-2xl'
                            src={s3Static + "personal-trainer/generated/trainer-with-banner.jpg"}
                            height={350}
                            width={350}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='StringsSG Personal Trainer Requirements'
                        />
                    </div>
                    <div className='py-2 flex items-center'>
                        <div className='space-y-5 leading-8'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Personal Training Certification (ACE, NASM, NCSF, etc.) preferred</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>CPR/AED certification (or willing to obtain)</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Experience in customizing fitness programs welcome at all levels</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Excellent communication and follow-up skills</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Compensation & Career Path</strong>
                </h2>
                <div className='max-w-5xl mx-auto space-y-8 p-5'>
                    <div className='text-center space-y-4'>
                        <h3 className='text-xl font-bold'>Base Salary</h3>
                        <p>Based on experience and certification</p>
                    </div>
                    <div className='text-center space-y-4'>
                        <h3 className='text-xl font-bold'>Additional Earnings</h3>
                        <p>Commission per session + Travel allowance</p>
                    </div>
                    <div className='text-center space-y-4'>
                        <h3 className='text-xl font-bold'>Career Growth</h3>
                        <p>Junior Trainer → Senior Trainer → Lead Trainer → Mentor Coach → Regional Fitness Lead</p>
                        <p>Long-term potential for equity (for early team members)</p>
                    </div>
                </div>
            </div>
            <div className='py-10 px-2 bg-slate-100'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>How to Apply</strong>
                </h2>
                <div className='max-w-3xl mx-auto text-center space-y-6 p-5'>
                    <p className='text-lg'>Ready to join our team? Submit your resume to our HR team.</p>
                    <div className='text-xl font-bold'>
                        Email: <a href="mailto:support@stringssg.com" className='text-orange-600'>support@stringssg.com</a>
                    </div>
                    <p>We welcome applications from trainers at all experience levels and look forward to hearing from you!</p>
                </div>
            </div>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>

    </>
  )
}
